import React, { useEffect } from "react";
import Card from "../components/Card";
import "./Work.css";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";

function Work() {
  const { ref, inView } = useInView();

  const project1 = useAnimation();
  const project2 = useAnimation();
  const project3 = useAnimation();

  useEffect(() => {
    if (inView) {
      project1.start({
        y: 0,
        opacity: 1,
        transition: { delay: 0.5 },
      });
      project2.start({
        y: 0,
        opacity: 1,
        transition: { delay: 1.3 },
      });
      project3.start({
        y: 0,
        opacity: 1,
        transition: { delay: 1.9 },
      });
    } else if (!inView) {
      project1.start({
        y: -100,
        opacity: 0,
      });
      project2.start({
        y: -100,
        opacity: 0,
      });
      project3.start({
        y: -100,
        opacity: 0,
      });
    }
  }, [inView, project1, project2, project3]);

  return (
    <div ref={ref} id="work" className="work">
      <div className="work__wrapper">
        <div className="work__header">
          <hr className="hr__line1" />
          <h2>My Projects</h2>
          <hr className="hr__line2" />
        </div>
        <div className="work__heading">
          <h3>Here are few of my notable Projects..</h3>
        </div>
        <motion.div animate={project1} className="projects__container">
          <div className="project__wrapper">
            <Card className="projectImg__container">
              <img
                className="card__img"
                src={require("../image/projects/img1.png")}
                alt=""
              />
            </Card>
            <Card className="project__description">
              <div className="alignProject__description">
                <div className="projectHeader">
                  <h5>Mobile Quiz App</h5>
                </div>
                <div className="projectTech">
                  <h6>Built With: </h6>
                  <h6>React Native, Redux and React Native Paper</h6>
                </div>
                <div className="projectDetails">
                  <h6>Project Description:</h6>
                  <p>
                    <span> I </span>love building application for mobile
                    devices. So, this quiz game is one of those application that
                    I built for fun. It is a fun little game with minimal UI
                    backed by react- native-paper and redux for state
                    management.
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </motion.div>
        {/*Second Project*/}
        <motion.div animate={project2} className="projects__container">
          <div className="project__wrapper">
            <Card className="projectImg__container">
              <img
                className="card__img"
                src={require("../image/projects/byrnihat.PNG")}
                alt=""
              />
            </Card>
            <Card className="project__description">
              <div className="alignProject__description">
                <div className="projectHeader">
                  <h5>OPD Management System</h5>
                </div>
                <div className="projectTech">
                  <h6>Built With: </h6>
                  <h6>NodeJs, React, Express and MongoDB</h6>
                </div>
                <div className="projectDetails">
                  <h6>Project Description:</h6>
                  <p>
                    <span> OPD Management System </span> is a one of my proud
                    project that i build for Byrnihat PHC, which is located in
                    Meghalaya. This piece of software aims to improve the
                    management of patients records. It has succeded in making
                    the patient records cleaner, easily manageable and also
                    accessing certain patients is made faster with search
                    filters.
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </motion.div>
        {/*Third Projects*/}
        <motion.div animate={project3} className="projects__container">
          <div className="project__wrapper">
            <Card className="projectImg__container">
              <img
                className="card__img"
                src={require("../image/projects/srservice.PNG")}
                alt=""
              />
            </Card>
            <Card className="project__description">
                <div className="alignProject__description">
                  <div className="projectHeader">
                    <h5>SR Service</h5>
                  </div>
                  <div className="projectTech">
                    <h6>Built With: </h6>
                    <h6>NextJS, React and MongoDB</h6>
                  </div>
                  <div className="projectDetails">
                    <h6>Project Description:</h6>
                    <p>
                      <span> SR Service </span> is a home appliance services and repairing solutions startup company based in Jaipur, Rajasthan.
                       This software manages the booking of service for the company and also holds contacts for service enquiry. Its is build with NextJs 
                       which is React framework and the NextJs makes it easier to maintain code and also makes the feature update easier.
                      
                    </p>
                  </div>
                </div>
              </Card>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default Work;
